/**
 * Truncate email address
 * @param {string} email - original email address
 * @param {number} maxLength - max display length (default: 20)
 * @param {string} ellipsis - ellipsis (default: "...")
 * @return {string} truncated email address
 */
export const truncateEmail = (email: string, maxLength = 20, ellipsis = '...') => {
	if (!email || email.length <= maxLength) {
		return email || ''
	}

	const parts = email.split('@')
	if (parts.length !== 2) {
		return email.substring(0, maxLength - ellipsis.length) + ellipsis
	}

	const [username, domain] = parts

	const domainLength = domain.length + 1

	if (domainLength > maxLength - ellipsis.length) {
		const availableLength = Math.max(maxLength - ellipsis.length, 5)
		const domainPart = `${domain.substring(0, availableLength - 2)}...`
		return `@${domainPart}`
	}

	const usernameMaxLength = maxLength - domainLength - ellipsis.length

	if (username.length > usernameMaxLength) {
		const truncatedUsername = username.substring(0, usernameMaxLength)
		return `${truncatedUsername}${ellipsis}@${domain}`
	}

	return email
}
